var map = {
	"./ic_accessibility_feature.svg": "7Nnc",
	"./ic_canva.svg": "GYBr",
	"./ic_complex_tickets.svg": "0xsI",
	"./ic_million_eyes.svg": "VSUO",
	"./ic_one_click.svg": "hlvD",
	"./ic_tracking.svg": "8nu4"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "3zO8";